<template>
  <!-- Modal for confiramtion Popup Unfavorite-->
  <Modal @click.prevent.stop rounded="42px" :isOpen="isOpen" :changeModalState="toggleDeleteModal">
    <div @click.prevent.stop>
      <h5 class="text-center mt-2 mb-[20px] font-bold text-[18px]">{{ $t('general.delete_product_from_favorites') }}</h5>
      <form @submit.prevent="deleteNotifications" class=" p-[20px] lg:px-[100px] " action="">
          <div class=" flex gap-2">
              <button @click="handleFavoritingProduct($event)" class="text-white bg-primary rounded-md text-center min-w-fit p-2 w-1/3 xl:w-1/2">{{
                  $t('general.unfavorite') }}</button>

              <button @click.prevent.stop="toggleDeleteModal(false)"
                  class="text-primary border border-primary rounded-md text-center min-w-fit p-2 w-1/3 xl:w-1/2">{{
                      $t('general.ignore') }}</button>
          </div>
      </form>
    </div>
  </Modal>
  <!-- Product Card Design -->
  <button
      v-if="isProductDesign"
      @click.prevent.stop="isFaved ? toggleDeleteModal(true) : handleFavoritingProduct($event)"
      :disabled="isFavoriting"
      type="button"
      :class="[
    'bg-white hover:brightness-90 transition-[filter,transform] duration-150 shadow-[0px_3px_6px_#00000029]',
    'w-[2.20rem] h-[2.20rem] 3xl:w-[2.25rem] 3xl:h-[2.25rem] rounded-full',
    !isFavoriting && 'active:scale-[0.87]'
  ].join(' ')"
  >
  <span
      :class="[
      'flex justify-center items-center favorite__btn select-none w-full h-full bg-transparent border-0 cursor-pointer rounded-[6px] md:rounded-[7px]',
      liked ? 'liked' : '',
      isFavoriting ? 'pointer-events-none cursor-default' : 'pointer-events-auto'
    ].join(' ')"
      :aria-label="liked ? 'Unfavorite' : 'Favorite'"
      :aria-labelledby="liked ? 'Unfavorite' : 'Favorite'"
      :title="liked ? 'Unfavorite' : 'Favorite'"
  >
    <img
        class="object-contain heart heart-icon !w-[1.25rem] mx-auto mb-0.5"
        :draggable="false"
        :src="liked ? favedIcon2 : unfavedIcon2"
        alt
    />
    <span class="sr-only">{{ liked ? 'Unfavorite' : 'Favorite' }}</span>
  </span>
  </button>


  <!-- product page design -->
  <button v-else @click.prevent.stop="isFaved ? toggleDeleteModal(true) : handleFavoritingProduct($event)" :disabled="isFavoriting"
    :class="`${allowAnimations ? 'heart-btn' : ''} ${liked ? 'liked' : ''} ${isFavoriting ? 'pointer-events-none cursor-default' : 'pointer-events-auto'} grid place-content-center w-[31px] h-[31px] lg:w-[35px] lg:h-[35px] 3xl:w-[36px] 3xl:h-[36px] shadow-[0px_3px_6px_#00000029] rounded-full favorite__btn select-none hover:bg-gray-100/75 bg-transparent border-0 cursor-pointer mb-[-0.25rem]`.trim()"
    :aria-label="liked ? 'Unfavorite' : 'Favorite'" :aria-labelledby="liked ? 'Unfavorite' : 'Favorite'"
    :title="liked ? 'Unfavorite' : 'Favorite'">
    <img class="object-contain heart heart-icon w-[1.1rem] md:w-[1.2rem] lg:w-[1.37rem]" :draggable="false" :src="liked ? favedIcon : unfavedIcon" alt />
    <span class="sr-only">{{ liked ? 'Unfavorite' : 'Favorite' }}</span>
  </button>
</template>

<script>
import favedIcon from "@/assets/images/heart-faved.svg";
import unfavedIcon from "@/assets/images/heart-unfaved.svg";
import favedIcon2 from "@/assets/icons/faved.svg";
import unfavedIcon2 from "@/assets/icons/unfaved.svg";
import Modal from "@/components/generic/Modal.vue";
export default {
  name: "FavoriteButton",
  components: {
    Modal
  },
  data() {
    return {
      unfavedIcon,
      favedIcon,
      favedIcon2,
      unfavedIcon2,
      isFavoriting: false,
      liked: false,
      isOpen: false
    };
  },
  props: {
    favoriteProductsIDs: {
      type: Array,
      required: true,
      default: () => []
    },
    id: {
      type: [String, Number],
      required: true,
      default: () => ""
    },
    withAnimations: {
      type: Boolean,
      required: false,
      default: false
    },
    isProductDesign: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isFaved() {
      return this.isUserLoggedIn && this.favoriteProductsIDs?.some(el => el == this.id);
    },
    allowAnimations() {
      return this.withAnimations && !prefersReducedMotion();
    }
  },
  methods: {
    toggleDeleteModal(state){
      this.isOpen = state;
    },
    heartit(e) {
      this.liked = !this.liked;
      if (!this.allowAnimations) {
        return;
      }
      const hearts = document.createElement('div');
      hearts.innerHTML = '<svg class="heart heart-pop one" viewBox="0 0 32 29.6"><path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"/></svg><svg class="heart heart-pop two" viewBox="0 0 32 29.6"><path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"/></svg><svg class="heart heart-pop three" viewBox="0 0 32 29.6"><path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"/></svg><svg class="heart heart-pop four" viewBox="0 0 32 29.6"><path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"/></svg><svg class="heart heart-pop five" viewBox="0 0 32 29.6"><path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"/></svg><svg class="heart heart-pop six" viewBox="0 0 32 29.6"><path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"/></svg><svg class="heart heart-pop seven" viewBox="0 0 32 29.6"><path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"/></svg><svg class="heart heart-pop eight" viewBox="0 0 32 29.6"><path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"/></svg><svg class="heart heart-pop nine" viewBox="0 0 32 29.6"><path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"/></svg>';
      e.target.appendChild(hearts);

      setTimeout(function () {
        e.target.removeChild(hearts);
      }, 3000);
    },
    updateItemFavoriteState({ state, productId }) {
      let newFavoriteArray = this.favoriteProductsIDs || [];
      if (state) {
        // unfavorite: remove it from the favorites list
        newFavoriteArray = this.favoriteProductsIDs?.filter(
          el => el != productId
        );
      } else {
        // favorite: add it to the list and remove potential duplicated items
        newFavoriteArray = [
          ...new Set([...this.favoriteProductsIDs, productId])
        ];
      }
      // update the favorite products' IDs array in the localStorage and Pinia
      this.useLocalStorage({
        type: "set",
        key: "favoriteProducts",
        value: newFavoriteArray
      });
    },
    handleFavoritingProduct(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      
      const isOffline = !navigator.onLine;
      if (this.isFavoriting || isOffline) {
        return;
      }
      
      this.isFavoriting = true;
      this.heartit(e);
      
      const bodyRequest = {
        product_id: this.id
      };
      this.makeRequest({
        owner: this.MAINROLES.user,
        url: !this.isFaved
          ? this.APIREQUESTS.user.addToFavorite.url
          : `${this.APIREQUESTS.user.removeFromFavorite.url}/${this.id}`,
        method: !this.isFaved
          ? this.APIREQUESTS.user.addToFavorite.method
          : this.APIREQUESTS.user.removeFromFavorite.method,
        formData: !this.isFaved ? JSON.stringify(bodyRequest) : ""
      })
        .then(res => {
          if (!res?.status) {
            this.liked = this.isFaved;
            // fail
            this.notify({
              type: "error",
              msg: res?.message || this.$t("general.failed")
            });
          } else {
            // success
            this.updateItemFavoriteState({
              state: this.isFaved,
              productId: this.id
            });
            if(this.liked){
              fbq('track', 'AddToWishlist');
            }
          }
        })
        .catch(err => {
          this.liked = this.isFaved;
          // console.error(err);
          this.notify({
            type: "error",
            msg:
              (typeof err === "string" ? err : err?.data?.message) ||
              this.$t("general.failed")
          });
        })
        .finally(() => {
          this.isFavoriting = false;
          this.toggleDeleteModal(false);
        });
    }
  },
  watch: {
    isFaved: {
      immediate: true,
      handler(val) {
        if (typeof val === 'boolean') {
          this.liked = val;
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped >
.heart {
  fill: gray;
  transition: fill .5s, transform .5s;
  pointer-events: none;

  &-btn {
    position: relative;
    background: transparent;

    &.liked {
      .heart {
        fill: var(--primary-lighter-clr);

        &-icon {
          transform: scale(1.2);
        }

        &-pop {
          animation-direction: normal;
        }
      }
    }

    &:active {
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    }
  }

  &-pop {
    position: absolute;
    width: 30%;
    opacity: 0;
    left: 0;
    animation: popHeart 1s ease forwards reverse;

    &.one {
      left: 1%;
      transform: rotate(-10deg);
      animation-delay: .45;
    }

    &.two {
      left: 15%;
      transform: rotate(8deg);
      animation-delay: .25s;
    }

    &.three {
      left: 30%;
      transform: rotate(-5deg);
      animation-delay: 0;
    }

    &.four {
      left: 50%;
      transform: rotate(-8deg);
      animation-delay: .3s;
    }

    &.five {
      left: 60%;
      transform: rotate(-10deg);
      animation-delay: .9s;
    }

    &.six {
      left: 70%;
      transform: rotate(-8deg);
      animation-delay: .2;
    }

    &.seven {
      left: 85%;
      transform: rotate(6deg);
      animation-delay: .35s;
    }

    &.eight {
      left: 90%;
      transform: rotate(-4deg);
      animation-delay: .5s;
    }

    &.nine {
      left: 95%;
      transform: rotate(8deg);
      animation-delay: .2s;
    }
  }

  @keyframes popHeart {
    0% {
      left: calc(50% - 7px);
      top: 10px;
    }

    20% {
      opacity: 1;
    }

    80% {
      top: -20px;
    }

    100% {
      opacity: 0;
    }
  }
}
</style>
